import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api.ts";
import type { ProductOut } from "@/types/api.ts";

export const productKeys = {
  all: ["products"] as const,
  list: (q?: string, categoryId?: string | null) =>
    [...productKeys.all, "list", q ?? "", categoryId ?? ""] as const,
  byBarcode: (barcode: string) => [...productKeys.all, "barcode", barcode] as const,
};

export function useProducts(q: string, categoryId?: string | null) {
  return useQuery({
    queryKey: productKeys.list(q, categoryId),
    queryFn: () =>
      api.get<ProductOut[]>("/products", {
        searchParams: {
          q: q || undefined,
          category_id: categoryId || undefined,
          limit: 50,
        },
      }),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
